import { render, staticRenderFns } from "./ConstructionTab.vue?vue&type=template&id=8c809084&scoped=true"
import script from "./ConstructionTab.vue?vue&type=script&lang=js"
export * from "./ConstructionTab.vue?vue&type=script&lang=js"
import style0 from "./ConstructionTab.vue?vue&type=style&index=0&id=8c809084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c809084",
  null
  
)

export default component.exports